module.exports = __webpack_public_path__ + "img/cerca-auto.15d5abaf.svg";